import { X } from "lucide-react-native";
import { FC, ReactNode, useEffect } from "react";
import { Modal, Pressable } from "react-native";

import { Center } from "./base";

interface ChartModalProps {
  children: ReactNode;
  onClose: () => void;
  visible: boolean;
}

const ChartModal: FC<ChartModalProps> = ({ children, onClose, visible }) => {
  useEffect(() => {
    if (!visible) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose, visible]);

  if (!visible) return null;

  return (
    <Modal
      animationType="fade"
      onRequestClose={onClose}
      transparent={true}
      visible={visible}
    >
      {/* Full screen pressable overlay */}
      <Center className="flex-1 bg-black/90">
        {/* Close button */}
        <Pressable
          className="absolute top-4 right-4 z-50 w-10 h-10 rounded-full bg-white/10 items-center justify-center"
          onPress={onClose}
          style={{
            cursor: "pointer",
            // @ts-expect-error Web-specific styles
            transition: "background-color 150ms ease-in-out",
          }}
        >
          <X color="rgb(var(--color-typography-0))" size={24} />
        </Pressable>

        {/* Main content - stop propagation so clicking content doesn't close */}
        <Pressable
          className="bg-white dark:bg-background-900 rounded-xl p-6 overflow-auto"
          onPress={(e) => e.stopPropagation()}
          style={{
            minWidth: "90%",
            maxWidth: "95%",
            maxHeight: "90%",
            display: "flex",
          }}
        >
          {children}
        </Pressable>
      </Center>
    </Modal>
  );
};

export default ChartModal;
